<app-table
  #table
  [config]="tableConfig">
</app-table>
